import { render, staticRenderFns } from "./WhereAreMyFundsStored.vue?vue&type=template&id=2303a532&scoped=true&"
import script from "./WhereAreMyFundsStored.vue?vue&type=script&lang=js&"
export * from "./WhereAreMyFundsStored.vue?vue&type=script&lang=js&"
import style0 from "./WhereAreMyFundsStored.vue?vue&type=style&index=0&id=2303a532&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2303a532",
  null
  
)

export default component.exports